import PropTypes from "prop-types";
import * as React from "react";
import { AlertTitle } from "@mui/material";

import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";

import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "tss-react/mui";
//import alertStyle from 'assets/jss/nextjs-material-kit-pro/components/alertStyle.js';
import CustomAlert from "../CustomAlert/CustomAlert";

import { useHasMounted } from "../../modules/utils";

import { fullWidth } from "../../assets/jss/nextjs-material-kit-pro";

const useStyles = makeStyles()({
  displayStart: { alignItems: "start" },
  fullWidth,
});

export default function DismissableAlert(props) {
  const { id, product, title, children, ...rest } = props;
  const { classes } = useStyles();

  // TOD: Check for 'closed' cookie for key, if found, return empty

  const [open, setOpen] = React.useState(true);

  const hasMounted = useHasMounted();
  if (!hasMounted) {
    return <div />;
  }
  const identifier = product ? `${id}-${product.id}` : id;

  const hasBeenClosed = open && localStorage?.getItem(identifier);
  if (hasBeenClosed) {
    setOpen(false);
  }

  return (
    <>
      <Collapse
        classes={{
          root: classes.fullWidth,
        }}
        in={open}
      >
        <CustomAlert
          {...rest}
          id={id}
          classes={{ action: classes.displayStart }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
                localStorage?.setItem(identifier, true);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <AlertTitle>{title}</AlertTitle>
          {children}
        </CustomAlert>
      </Collapse>
    </>
  );
}

DismissableAlert.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  product: PropTypes.shape({
    id: PropTypes.string,
  }),
  title: PropTypes.string,
};
